import { render, staticRenderFns } from "./ClientInitialUser.vue?vue&type=template&id=ce4f6428"
import script from "./ClientInitialUser.vue?vue&type=script&lang=js"
export * from "./ClientInitialUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports